<template lang="pug">
.childItemComponent(:class="`_${variant}`")
  user-item-component(
    :user-item="userItem"
    :with-shadow="withShadow"
    :show-favorite="showFavorite"
    :show-info="showInfo"
    :show-action-button="showActionButton"
    :label-action-button="labelActionButton"
    @action:favorite-off="$emit('action:favorite-off')"
    @action:favorite-on="$emit('action:favorite-on')"
    @action:click-on-item="$emit('action:click-on-item')"
    @action:click-on-info="$emit('action:click-on-info')"
    @action:click-on-buy="$emit('action:click-on-buy')"
    @action:click-on-action="$emit('action:click-on-action')"
  )
    template(v-slot:progress)
      component.progress(
        :is="progressComponent"
        :child-item="childItem"
      )

</template>

<script>
import UserItemComponent from './UiUserItem'
import ProgressBookComponent from './UiChildItemProgressBook'
import ProgressVprComponent from './UiChildItemProgressVpr'
import ChildBook from '@/models/ChildBook'
import ChildVpr from '@/models/ChildVpr'
export default {
  components: {
    UserItemComponent,
    ProgressBookComponent,
    ProgressVprComponent
  },
  props: {
    childItem: {
      type: [ChildBook, ChildVpr],
      required: true
    },
    showFavorite: {
      type: Boolean,
      default: true
    },
    withShadow: {
      type: Boolean,
      default: true
    },
    showInfo: Boolean,
    showActionButton: Boolean,
    labelActionButton: {
      type: String,
      default: 'Заниматься'
    },
    variant: {
      type: String,
      default: 'default'
    }
  },
  emits: [
    'action:favorite-off',
    'action:favorite-on',
    'action:click-on-item',
    'action:click-on-info',
    'action:click-on-buy',
    'action:click-on-action'
  ],
  computed: {
    componentClasses () {
      return {
        _book: this.userItem.isBook,
        _vpr: this.userItem.isVpr
      }
    },
    userItem () {
      return this.childItem.userItem
    },
    progressComponent () {
      if (this.userItem.isBook) {
        return 'ProgressBookComponent'
      } else if (this.userItem.isVpr) {
        return 'ProgressVprComponent'
      } else return null
    }

  }
}
</script>

<style lang="sass" scoped>
.childItemComponent
  width: 100%
  height: 100%
  display: flex
  flex-flow: column

  .progress
    margin-bottom: 6*$u
    @media (max-width: $padWidth)
      margin-bottom: 3*$u

  &:deep(.itemAbstractComponent)
    // IMAGE SIZE PER SCREEN
    > .itemWrapper
      > .imageBackground
        > .imageWrapper
          > .image
            max-width: 63*$u
            @media (max-width: $padWidth)
              max-width: 52*$u

    // FONTS
    > .itemWrapper
      > .contentWrapper
        > .title
          @include font('h2')
          @media (max-width: $padWidth)
            @include font('t18-demibold')
        > .text
          @include font('t18-regular')
          @media (max-width: $padWidth)
            @include font('t16-regular')

</style>
